import React from 'react'
import Header from '../main/Header'
import Footer from '../main/Footer'
import { Link } from 'react-router-dom'

export default function Gallery() {
    return (
        <>
            <Header />
            <section className="page-title">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-md-12">
                            <div className="breadcrumbs-wrap">
                                <h1 className="breadcrumb-title">Our Gallery</h1>
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link hto={"/"}>Home</Link>
                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page">
                                            Gallery
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className="gallery-container py-5">
                <div className="container">
                    {/* <h2 className="text-center mb-4">Our Gallery</h2> */}
                    <div className="row g-4">
                        <div className="col-lg-3 col-md-4 col-sm-6 mt-3">
                            <div className="gallery-item">
                                <img src="assets/images/1.jpg" alt="Gallery 1" className="img-fluid" />
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 mt-3">
                            <div className="gallery-item">
                                <img src="assets/images/2.jpg" alt="Gallery 2" className="img-fluid" />
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 mt-3">
                            <div className="gallery-item">
                                <img src="assets/images/3.jpg" alt="Gallery 3" className="img-fluid" />
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 mt-3">
                            <div className="gallery-item">
                                <img src="assets/images/4.jpg" alt="Gallery 4" className="img-fluid" />
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <Footer />
        </>
    )
}
